export const defaultGrades = () => [
    {id: 'grade-1', label: 'Poor', order: 0},
    {id: 'grade-2', label: 'Satisfactory', order: 1},
    {id: 'grade-3', label: 'Good', order: 2},
    {id: 'grade-4', label: 'Excellent', order: 3},
];

export const defaultMeters = () => {
    return [{
        id: 'meter-1',
        label: 'meter-1',
        min: 0,
        max: 100,
        value: 0,
    }, {
        id: 'meter-2',
        label: 'meter-2',
        min: 0,
        max: 100,
        value: 0,
    }, {
        id: 'meter-3',
        label: 'meter-3',
        min: 0,
        max: 100,
        value: 0,
    }, {
        id: 'meter-4',
        label: 'meter-4',
        min: 0,
        max: 100,
        value: 0,
    }, {
        id: 'meter-5',
        label: 'meter-5',
        min: 0,
        max: 100,
        value: 0,
    }, {
        id: 'meter-6',
        label: 'meter-6',
        min: 0,
        max: 100,
        value: 0,
    }, {
        id: 'meter-7',
        label: 'meter-7',
        min: 0,
        max: 100,
        value: 0,
    }];
};